import React from 'react';
import Type from 'prop-types';
import noop from 'lodash/noop';
import { BottomNavigation, BottomNavigationAction } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import useStyles from './BottomNavMenu.styles';

const BottomNavMenu = props => {
  const { activeTab, type, tabs, onChange } = props;
  const classes = useStyles();

  function handleChange(event, newValue) {
    onChange(newValue);
  }

  return (
    <BottomNavigation
      value={activeTab}
      onChange={handleChange}
      showLabels
      className={classes.positionFixed}
    >
      {tabs.map(({ value, label, icon: Icon }) => {
        const linkProps = type === 'link' ? { component: RouterLink, to: value } : {};

        return (
          <BottomNavigationAction
            key={value}
            label={label}
            value={value}
            icon={<Icon />}
            classes={{ root: classes.button }}
            {...linkProps}
          />
        );
      })}
    </BottomNavigation>
  );
};

BottomNavMenu.propTypes = {
  activeTab: Type.oneOfType([Type.string.isRequired, Type.number.isRequired]).isRequired,
  type: Type.oneOf(['button', 'link']),
  tabs: Type.arrayOf(
    Type.shape({
      label: Type.string.isRequired,
      value: Type.string.isRequired,
      icon: Type.elementType,
    }).isRequired,
  ).isRequired,
  onChange: Type.func,
};

BottomNavMenu.defaultProps = {
  type: 'button',
  onChange: noop,
};

export default BottomNavMenu;
